export default __webpack_public_path__ + "static/InterDisplay-Medium-eb51672e54034ea6cc49230a203668e9.woff2";